@let referentiel = this.referentiel();

@if (referentiel) {
  <div hlmSidebarWrapper>
    <hlm-sidebar collapsible="icon" variant="sidebar">
      <div hlmSidebarHeader>
        <div class="gap-xxs flex">
          <a
            [routerLink]="['../../../..']"
            size="xxl"
            hlmBtn
            variant="ghost"
            size="icon"
            hlmTooltipTrigger="Retour à l'accueil"
            position="right"
          >
            <ng-icon name="lucideArrowLeft" hlm />
          </a>
          <div class="flex flex-col group-data-[collapsible=icon]:hidden">
            <h1 class="text-text-primary title-small-semibold">Référentiel Métier</h1>
            <span class="text-text-tertiary paragraph-medium-medium">{{ referentiel.nom }}</span>
          </div>
        </div>

        <button
          [hlmTooltipTrigger]="isSidebarOpen() ? `Fermer le menu` : 'Ouvrir le menu'"
          hlmSidebarTrigger
          position="right"
        ></button>
      </div>
      <div hlmSidebarContent>
        <div hlmSidebarGroup>
          <div hlmSidebarGroupContent>
            <ul hlmSidebarMenu>
              @for (item of _items(); track item.title) {
                <li hlmSidebarMenuItem>
                  <a
                    #rla="routerLinkActive"
                    [routerLink]="[item.url]"
                    [isActive]="rla.isActive"
                    [hlmTooltipTrigger]="item.title"
                    [hlmTooltipDisabled]="isSidebarOpen()"
                    hlmSidebarMenuButton
                    routerLinkActive="active"
                    position="right"
                  >
                    <ng-icon [name]="item.icon" hlm size="sm" />
                    <span>{{ item.title }}</span>
                  </a>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    </hlm-sidebar>

    <div class="size-full">
      <router-outlet></router-outlet>
    </div>
  </div>
}
